import SvgColor from "../../components/svg-color";
import { FaDatabase } from "react-icons/fa";

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const navConfig = [
  {
    title: 'Dashboard',
    path: '/admin',
    icon: icon('ic_analytics'),
  },
  {
    title: 'Logs',
    path: '/admin/logs',
    icon: <FaDatabase size={24} />,
  }
  // {
  //   title: 'Albums',
  //   path: '/admin/album',
  //   icon: icon('ic_album'),
  // },
  // {
  //   title: 'plan',
  //   path: '/plan',
  //   icon: icon('ic_cart'),
  // },
  // {
  //   title: 'setting',
  //   path: '/admin/setting',
  //   icon: icon('ic_setting'),
  // },
];

export default navConfig;
